var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#004080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_58657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4994 18.4713C16.074 18.4713 15.6486 18.3318 15.2857 18.049L9.91113 13.8699V19.7066C9.91113 20.3886 10.4642 20.9419 11.1464 20.9419H21.8523C22.5346 20.9419 23.0876 20.3889 23.0876 19.7066V13.8699L17.7141 18.0519C17.3512 18.3324 16.924 18.4713 16.4994 18.4713ZM10.3304 13.1518L15.7914 17.4007C16.208 17.725 16.7917 17.725 17.2084 17.4007L22.6694 13.1518C22.91 12.946 23.0876 12.6294 23.0876 12.2949C23.0876 11.6126 22.5343 11.0596 21.8523 11.0596H11.1464C10.4642 11.0596 9.91113 11.6126 9.91113 12.2949C9.91113 12.6294 10.0658 12.946 10.3304 13.1518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_58657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1765,
    height: 13.1765,
    fill: "white",
    transform: "translate(9.91113 9.41211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/EmailWhite.b62bb2f0c02e48500ffd15aa5ec5766a.svg";
export { ForwardRef as ReactComponent };